import { LitElement, html, css, classMap, utils } from '@hh/global.js'
const { debounce } = utils

class HHScrollMore extends LitElement {
  static properties = {
    containerSelector: {
      type: String,
      attribute: 'container-selector',
    },
    show: {
      type: Boolean,
    },
    hasOverflow: {
      type: Boolean,
    },
  }

  constructor() {
    super()

    this.show = false
    this.hasOverflow = false

    this.debounceOnScroll = debounce(this.onScroll.bind(this), 50)
  }

  get scrollContainer() {
    return document.querySelector(this.containerSelector) ?? null
  }

  connectedCallback() {
    super.connectedCallback()

    window.addEventListener(
      'drawer:open',
      this.checkScrollMoreComponent.bind(this)
    )
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.debounceOnScroll)
    }
    window.removeEventListener('drawer:open', this.checkScrollMoreComponent)
  }

  firstUpdated() {
    if (this.scrollContainer) {
      this.checkOverflow()
      this.scrollContainer.addEventListener('scroll', this.debounceOnScroll)
    }
  }

  updated(changedProperties) {
    if (changedProperties.has('hasOverflow')) {
      this.show = this.hasOverflow
    }
  }

  checkOverflow() {
    const { scrollHeight, offsetHeight } = this.scrollContainer
    this.hasOverflow = scrollHeight > offsetHeight
  }

  checkScrollMoreComponent(e) {
    const hasScrollMoreComponent = e.target.querySelector('hh-scroll-more')
    if (hasScrollMoreComponent) {
      this.checkOverflow()
    }
  }

  onScroll() {
    if (!this.hasOverflow) return
    const { scrollHeight, offsetHeight, scrollTop } = this.scrollContainer
    const isBottom = scrollHeight - offsetHeight === scrollTop
    this.show = !isBottom
  }

  onScrollMoreClick() {
    this.scrollContainer.scrollBy({
      top: this.scrollContainer.offsetHeight,
      behavior: 'smooth',
    })
  }

  render() {
    return html`
      <div
        class=${classMap({
          container: true,
          show: this.show,
        })}
      >
        <button class="inner" @click=${this.onScrollMoreClick}>
          <slot></slot>
        </button>
      </div>
    `
  }

  static styles = css`
    :host *,
    :host *::before,
    :host *::after {
      box-sizing: border-box;
    }

    .container {
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 0.3125rem;
      opacity: 0;
      z-index: -1;
      pointer-events: none;
      transition: opacity var(--hh-duration-medium) ease-in-out;
    }

    .container.show {
      opacity: 1;
      z-index: 1;
      pointer-events: auto;
    }

    .inner {
      display: flex;
      align-items: center;
      column-gap: 0.3125rem;
      color: var(--hh-color-day);
      background-color: #3c3c3cad;
      font: var(--hh-body-small-font);
      letter-spacing: var(--hh-body-small-letter-spacing);
      padding: 0.6250rem 1.1250rem;
      appearance: none;
      border: none;
      cursor: pointer;
    }
  `
}

customElements.define('hh-scroll-more', HHScrollMore)
